function Header(props) {
    const { white, left } = props
    const colorClass = white ? 'text-white' : 'text-darkblue'
    const alignClass = left ? 'text-left' : 'text-center'
    return (
        <h2 className={`text-3xl sm:text-4xl lg:text-5xl font-semibold ${colorClass} ${alignClass}`}>{props.children}</h2>
    )
}

export default Header
